import { useIntl } from '@capsicum/common';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const resolver = zodResolver(
	z.object({
		checkboxA: z.literal<boolean>(true),
		checkboxB: z.literal<boolean>(true),
		checkboxC: z.literal<boolean>(true),
		checkboxD: z.literal<boolean>(true),
		checkboxE: z.literal<boolean>(true)
	})
);

export const useExportAndCloseAccountConfirmation = () => {
	const { $t } = useIntl();

	return {
		intlTexts: {
			cancel: $t('global.button.cancel'),
			checkboxA: $t('settings.accountManagement.exportAndCloseAccountConfirmation.checkboxA'),
			checkboxB: $t('settings.accountManagement.exportAndCloseAccountConfirmation.checkboxB'),
			checkboxC: $t('settings.accountManagement.exportAndCloseAccountConfirmation.checkboxC'),
			checkboxD: $t('settings.accountManagement.exportAndCloseAccountConfirmation.checkboxD'),
			checkboxE: $t('settings.accountManagement.exportAndCloseAccountConfirmation.checkboxE'),
			confirmButton: $t('settings.accountManagement.exportAndCloseAccountConfirmation.confirmButton'),
			title: $t('settings.accountManagement.exportAndCloseAccountConfirmation.title')
		},
		resolver
	};
};
